export const passwordRegex =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
export const phoneNumberRegex = /^\d{10}$/;
export const numbRegex = /^\d+(\.\d+)?$/
export const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
export const percentRegex = /^100$|^\d{0,2}(\.\d+)?$/;
export const imageRegex = /^https?:\/\//i;